import { useState } from "react";
import Jsona from "jsona";
import { visionURL } from "../config/environment";
import JsonApiService from "../services/jsonapiService";

const dataFormatter = new Jsona();

const policiesApiService = async () =>
  new JsonApiService("policies", {
    baseUrl: `${visionURL}/admin_console/api/content`,
    credentials: "include"
  });

const usePolicies = () => {
  const [isLoading, setIsLoading] = useState(false);

  const fetchPolicy = async id => {
    setIsLoading(true);
    const service = await policiesApiService();
    const response = await service.find(id).then(response => response.json());
    setIsLoading(false);
    return dataFormatter.deserialize(response);
  };

  const fetchPolicyVersion = async (policyId, id) => {
    setIsLoading(true);
    const service = await policiesApiService();
    const response = await service
      .relatedResource(policyId, "versions", id)
      .then(response => response.json());
    setIsLoading(false);
    return dataFormatter.deserialize(response);
  };

  const fetchPolicies = async ({ page, filters }) => {
    setIsLoading(true);
    const service = await policiesApiService();
    const response = await service
      .page(page)
      .where(filters)
      .all()
      .then(response => response.json());
    setIsLoading(false);
    return {
      data: dataFormatter.deserialize(response),
      totalCount: response.meta.totalCount
    };
  };

  const createPolicy = async data => {
    setIsLoading(true);
    const service = await policiesApiService();
    const response = await service
      .create(JSON.stringify(data))
      .then(response => response.json());
    setIsLoading(false);
    return response;
  };

  return {
    fetchPolicy,
    fetchPolicyVersion,
    fetchPolicies,
    createPolicy,
    isLoading
  };
};

export default usePolicies;
